import { FC } from "react";
import { IMenuItem } from "types/menu";
import { useToggleState } from "hooks";
import MenuOrderModal from "./MenuOrderModal";
import { DiscountLabel } from "shared-widgets";

const MenuItem: FC<{ item: IMenuItem }> = ({ item }) => {
	const modalToggle = useToggleState(false);
	return (
		<div
			className={`p-2 rounded ${item.isSoldOut ? "opacity-50 pointer-events-none" : ""} bg-gray-primary flex flex-col gap-y-1 justify-between`}
			onClick={modalToggle.on}
		>
			<MenuOrderModal item={item} toggle={modalToggle} />
			<div className="font-medium text-sm">{item.titleEn}</div>
			<div className="text-xs text-secondary flex justify-between items-center">
				{item.isSoldOut ? <span className="text-red-400">Sold Out</span> : <span className="text-green-400">Available</span>}

				<DiscountLabel item={item} />
			</div>
		</div>
	);
};

export default MenuItem;
